import { render, staticRenderFns } from "./FundAccountSelect.vue?vue&type=template&id=523b8764&scoped=true"
import script from "./FundAccountSelect.vue?vue&type=script&lang=js"
export * from "./FundAccountSelect.vue?vue&type=script&lang=js"
import style0 from "./FundAccountSelect.vue?vue&type=style&index=0&id=523b8764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523b8764",
  null
  
)

export default component.exports